import { useLoader } from '@react-three/fiber';
import * as THREE from 'three';
import canvas_background from '~/assets/img/background/canvas_background.jpg';

export default function AssetBackground() {
  const texture = useLoader(THREE.TextureLoader, canvas_background);
  return (
    <mesh>
      <sphereGeometry attach='geometry' args={[10, 6, 4]} />
      <meshBasicMaterial
        attach='material'
        map={texture}
        side={THREE.BackSide}
      />
    </mesh>
  );
}
